// @flow
import * as React from 'react';
import {
    View,
} from 'react-native';
import Text from './CustomText/CustomText';
import ProfileIcon from '../Icons/ProfileIcon';
import homeScreenStyles from '../styles/home';

type Props = {
    name: String,
    imageUrl: String,
};

const Profile = (props: Props) => {
    const {
        name, imageUrl,
    } = props;
    return (
        <View style={homeScreenStyles.image_container}>
            <View style={homeScreenStyles.image_wrapper}>
                <ProfileIcon imageUrl={imageUrl} />
            </View>
            <Text style={homeScreenStyles.text}>{name}</Text>
        </View>
    );
};

export default Profile;
